import React, { useState, useEffect, useRef } from "react";
import "./ClassVideo.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import { useLocation } from "react-router-dom";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseIcon from "@mui/icons-material/Pause";

export default function ClassVideo() {
  const location = useLocation();
  const { link } = location.state || {};
  const videoRef = useRef(null);
  const progressbarRef = useRef(null);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [currentTime, setCurrentTime] = useState("00:00");
  const [duration, setDuration] = useState("00:00");
  const [fullTime, setFullTime] = useState(0);
  const [played, setPlayed] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const handleTrackerTouchStart = () => {
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (isDragging) {
      const rect = progressbarRef.current.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - rect.left;
      const newPlayed = offsetX / rect.width;

      setPlayed(newPlayed);
      videoRef.current.currentTime = newPlayed * videoRef.current.duration;
    }
  };
  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    const trackerPointer = progressbarRef.current;

    if (trackerPointer) {
      trackerPointer.addEventListener("touchstart", handleTrackerTouchStart);
      trackerPointer.addEventListener("touchmove", handleTouchMove);
      trackerPointer.addEventListener("touchend", handleTouchEnd);
    }

    return () => {
      if (trackerPointer) {
        trackerPointer.removeEventListener(
          "touchstart",
          handleTrackerTouchStart
        );
        trackerPointer.removeEventListener("touchmove", handleTouchMove);
        trackerPointer.removeEventListener("touchend", handleTouchEnd);
      }
    };
  }, [isDragging, progressbarRef]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const playPauseHandler = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  const handleProgress = (e) => {
    const { currentTime, duration } = e.target;
    setPlayed(currentTime / duration);
    setCurrentTime(currentTime);
    setDuration(duration);
    setFullTime(duration);
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      const updateProgress = () => {
        const currentTimeInSeconds = Math.floor(videoElement.currentTime);
        const fullTimeInSeconds = Math.floor(videoElement.duration);
        setCurrentTime(formatTime(currentTimeInSeconds));
        setDuration(formatTime(fullTimeInSeconds));
      };

      const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        if (hours > 0) {
          return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
            2,
            "0"
          )}:${String(remainingSeconds).padStart(2, "0")}`;
        } else {
          return `${String(minutes).padStart(2, "0")}:${String(
            remainingSeconds
          ).padStart(2, "0")}`;
        }
      };

      videoElement.addEventListener("timeupdate", updateProgress);

      return () => {
        videoElement.removeEventListener("timeupdate", updateProgress);
      };
    }
  }, [currentTime, duration]);

  const handleProgressBarClick = (e) => {
    const progressBar = e.currentTarget;
    const clickPositionX = e.pageX - progressBar.getBoundingClientRect().left;
    const clickedPercentage = clickPositionX / progressBar.clientWidth;
    const newTime = clickedPercentage * fullTime;

    if (!isNaN(newTime) && isFinite(newTime)) {
      videoRef.current.currentTime = newTime;
      setPlayed(clickedPercentage);
    }
  };

  return (
    <div className="bgContainer" style={{backgroundColor: "#000"}}>
      <div className="pageWrapper">
        <div className="classVideo">
          <div className="pageHeader centeredFlex classVideoHeader">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
              style={{ zIndex: "999" }}
            />
          </div>
          {showHamburgerMenu && (
            <HamburgerMenu
              showHamburgerMenu={showHamburgerMenu}
              onHide={hideMenuHandler}
            />
          )}
          {link && (
            <div className="classVideoConatiner">
              <video
                ref={videoRef}
                autoPlay
                className="offlineVideo"
                onTimeUpdate={handleProgress}
              >
                <source src={link} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="customControls">
                <div className="topControls centeredFlex">
                  <span className="fullTime">{duration}</span>
                  <div
                    className="progressbarContainer"
                    onClick={handleProgressBarClick}
                    ref={progressbarRef}
                    onTouchStart={handleTrackerTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                  >
                    <div
                      className="progressBarTracker"
                      style={{ width: `${played * 100}%` }}
                    ></div>
                    <div
                      className="trackerPointer"
                      style={{ left: `${played * 100}%` }}
                    ></div>
                  </div>

                  <span className="currentTime">{currentTime}</span>
                </div>
                <div className="bottomControls centeredFlex">
                  <button onClick={() => (videoRef.current.currentTime += 10)}>
                    <SkipNextIcon className="customPlayerIcon" />
                  </button>
                  <button onClick={playPauseHandler}>
                    {videoRef.current && videoRef.current.paused ? (
                      <PlayCircleIcon className="customPlayerIcon" />
                    ) : (
                      <PauseIcon className="customPlayerIcon" />
                    )}
                  </button>
                  <button onClick={() => (videoRef.current.currentTime -= 10)}>
                    <SkipPreviousIcon className="customPlayerIcon" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
